var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Autocomplete, TextField } from '@mui/material';
export var UISelect = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, label = _a.label, _b = _a.multiple, multiple = _b === void 0 ? false : _b, _c = _a.freeSolo, freeSolo = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.disableClearable, disableClearable = _e === void 0 ? false : _e, _f = _a.error, error = _f === void 0 ? false : _f, helperText = _a.helperText, sx = _a.sx;
    var getOptionLabel = function (option) {
        if (typeof option === 'string') {
            var found = options.find(function (o) { return o.value === option; });
            if (found) {
                return found.label;
            }
            return option;
        }
        return option.label;
    };
    var isOptionEqualToValue = function (option, value) {
        return option.value === value.value;
    };
    var handleChange = function (_, newValue) {
        if (newValue === null) {
            onChange(null);
            return;
        }
        if (Array.isArray(newValue)) {
            var processedValue = newValue.map(function (item) {
                return typeof item === 'string'
                    ? { label: item, value: item }
                    : item;
            });
            onChange(processedValue);
            return;
        }
        if (typeof newValue === 'string') {
            ;
            onChange({
                label: newValue,
                value: newValue,
            });
            return;
        }
        ;
        onChange(newValue);
    };
    return (_jsx(Autocomplete, { sx: __assign({ minWidth: '8rem' }, sx), multiple: multiple, freeSolo: freeSolo, options: options, disableClearable: disableClearable, value: value, onChange: handleChange, getOptionLabel: getOptionLabel, isOptionEqualToValue: isOptionEqualToValue, disabled: disabled, disableCloseOnSelect: multiple, renderOption: function (props, option) {
            return (_createElement("li", __assign({}, props, { key: "".concat(option.value) }), option.label));
        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: label, error: error, helperText: helperText, placeholder: "Select an option" }))); } }));
};
